<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="betteruptimeTicketModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Create Ticket for Outages
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section>
                <div v-if="recentTickets.length>0" class="row">
                  <div  class="col-md-12">
                    <h6>Recently Created Tickets:</h6>
                    <div class="row mt-2" v-for="(row, index) in recentTickets" :key="index">
                      <!--                        {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}}-->
                      <div class="col-md-12">{{ formatDate(row.createdAt) }}  <b>- </b>  <a :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`" target="_blank">{{row.ticketId}}</a> <b v-if="row.subject"> -</b> {{row.subject || ''}}  <b> -</b>
                        <small><span class="fs-10 badge mr-2 ml-5" :class="{'badge-primary':(row.status === 'Open'),'badge-default':(row.status ===  'Closed'), 'badge-danger':(row.status ===  'Client-Reply'), 'badge-success': (row.status ===  'Answered'),'badge-info': (row.status ===  'In-Progress'), 'badge-warning': row.status === 'Pending Client'}">{{ row.status }}</span></small>
                        <b> -</b>  by <b>{{ row.addedBy }}</b></div>
                    </div>
                    <hr>
<!--                    <span v-for="(row, index) in tickets" :key="index">-->
<!--                    {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}} <br>-->
<!--                  </span>-->
                  </div>
                  <br>
                </div>
              </section>
              <section>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Subject:</label>
                      <input type="text" v-model="subject" name="subject" class="form-control" />
                    </div>
                  </div>
                  <section >
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                          <option value="Pending Client">Pending Client</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>
                    <!--                    <div class="row">-->
                    <!--                      <div class="col-md-12" v-if="action !== 'Leave in migration'">-->
                    <!--                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">-->
                    <!--                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />-->
                    <!--                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </section>
                  <!--                  <div class="row mt-3" >-->
                  <!--                    <div class="col-md-12">-->
                  <!--                      <span class="text-danger">Ticket ID is not associated with this migration.</span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="row">
                    <div class="col-md-12 ml-3 mt-3">
                      <input class="form-check-input" type="checkbox" v-model="assignTicketUrl" /> Assign Ticket URL?
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="loading">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import moment from "moment";

export default {
  name: "betteruptimeTicketModal",
  data(){
    return {
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      subject: '',
      type: null,
      loading: false,
      sendTicketReply: false,
      index: null,
      action: 'Leave in migration',
      requiredTasks: [],
      presetMacros: [],
      outageDetail: {},
      tickets: [],
      assignTicketUrl: false
    }
  },
  mounted() {
    // this.getMonitorTickets()
  },
  computed: {
    user () {
      return this.$store.getters.user;
    },
    recentTickets() {
      const tickets = this.tickets.filter(el => el.type !== 'domainExpiry');
      return tickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,2);
    }
  },
  methods: {
    formatDate(date){
      return moment(date).local().fromNow()
    },
    async getMonitorTickets(){
      try{
        this.loading = true
        this.tickets = [];
        let ticketRef=await db.collection('monitorTickets').doc(this.outageDetail.id.toString()).get()
        if(ticketRef.exists){
          const {tickets} = ticketRef.data()
          this.tickets= tickets;
          this.tickets = this.tickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,2);
          const response = await this.$http.post('/host-bill/fetch-bulk-ticket-details', {
            grant_type: 'token',
            ticketData: this.tickets
          });
          console.log('response', response.data)
          this.tickets = response.data.ticketData
        }
      } catch (e) {
        console.log('error while getting ticket details', e.toString())
      } finally {
        this.loading = false
      }
    },
    async useThisMacro (macro) {
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      if(!this.outageDetail.uid) {
        let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
        domain = domain.split('/')[0];
        msg = msg.replace(/{domain}/g, domain)
        msg = msg.replace(/{signature}/g, this.user.signature)
        this.ticketMessage = msg;
        this.ticketStatus = (macro.status) ? macro.status : 'Answered';
        this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
        this.subject= macro.title ? macro.title.replace(/{domain}/g, domain) : ''
        this.loading = false
        return true
      }
      const userRef = await db.collection('users').doc(this.outageDetail.uid).get()
      const user = userRef.data()
      let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
      domain = domain.split('/')[0];
      msg = msg.replace(/{firstName}/g, user.firstName)
      msg = msg.replace(/{lastName}/g, user.lastName)
      msg = msg.replace(/{domain}/g, domain)
      msg = msg.replace(/{email}/g, user.email)
      msg = msg.replace(/{signature}/g, this.user.signature)
      this.ticketMessage = msg;
      this.ticketStatus = (macro.status) ? macro.status : 'Answered';
      this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
      this.subject= macro.title ? macro.title.replace(/{domain}/g, domain) : ''
      this.loading = false
    },
    initialState() {
      return {
        ticketMessage: null,
        ticketStatus: 'Answered',
        ticketPriority: 'Low',
        subject: '',
        type: null,
        loading: false,
        sendTicketReply: false,
        index: null,
        action: 'Leave in migration',
        requiredTasks: [],
        presetMacros: [],
        outageDetail: {},
        tickets: [],
        assignTicketUrl: false
      }
    },
    async load (presets, outage, from) {
      if (outage && outage.portal_version === 'v2') {
        const domain = outage.url ? (outage.url.includes('https://') ? outage.url.split('https://')[1] : outage.url) : '';
        const name = `${outage.firstName} ${outage.lastName}` || '';
        const params = new URLSearchParams({ from: 'monitor', domain: domain, name: name }).toString();
        window.open('http://localhost:3000/support-tickets/create?' + params, '_blank');
        return;
      }
      Object.assign(this.$data, this.initialState());
      this.presetMacros=presets
      this.outageDetail=outage
      if (from === 'checkin' || from === 'ticketIcon') {
        this.assignTicketUrl = true
        const macro = this.presetMacros.find(reply => reply.title.includes('Issue detected on'))
        if (macro) {
          await this.useThisMacro(macro)
        }
        await this.submit(from)
      }
      if(from !== 'ticketIcon'){
        $('#betteruptimeTicketModal').modal('show');
      }
      await this.getMonitorTickets()
      console.log(outage)
    },
    async submit (from) {
      try {
        this.loading = true
        let accountRef = {}
        if(!this.outageDetail.uid) {
          if(this.outageDetail.nonWpoMonitor){
            accountRef.customerID = this.outageDetail.clientId || ''
          } else {
            return true
          }
        } else {
          accountRef = await db.collection('users').doc(this.outageDetail.uid).get();
          accountRef = accountRef.data();
        }
        let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
        domain = domain.split('/')[0];
        let response=await this.$http.post('host-bill/open-new-ticket', {
          domain,
          grant_type: 'token',
          message: this.ticketMessage,
          priority: this.ticketPriority,
          clientID: accountRef.customerID,
          subject: this.subject,
          status: this.ticketStatus,
          email: accountRef.email || '',
          name: this.user.firstName + ' ' + this.user.lastName
        })
        console.log('response', response)
        this.tickets.push({
          domain,
          subject: this.subject,
          message: this.ticketMessage,
          priority: this.ticketPriority,
          ticketId: response.data.ticket_id,
          status: this.ticketStatus,
          testId: this.outageDetail.id,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })
        await db.collection('monitorTickets').doc(this.outageDetail.id.toString()).set({tickets: this.tickets})
        if(this.assignTicketUrl){
          await db.collection('zabbixMonitors').doc(this.outageDetail.id.toString())
              .update({ticket_url: `https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`})
        }
        if(from === 'ticketIcon') {
          this.$emit('changeLoading', {id: this.outageDetail.id, flag: false })
        } else {
          swal({
            title: "Success",
            text: 'Ticket has been created successfully',
            type: "success"
          })
        }
        // window.open(`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`, '_blank');
      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }finally
      {
        this.loading = false
        this.ticketMessage=''
        this.subject=''
        $('#betteruptimeTicketModal').modal('hide');

      }
    },
  }
}
</script>



<style lang="scss" scoped>
.preset {
  height: 230px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
